import { render, staticRenderFns } from "./model.vue?vue&type=template&id=13349e86&scoped=true&lang=pug&"
import script from "./model.vue?vue&type=script&lang=ts&"
export * from "./model.vue?vue&type=script&lang=ts&"
import style0 from "./model.vue?vue&type=style&index=0&id=13349e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13349e86",
  null
  
)

export default component.exports